import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import shortid from 'shortid'
import axios from 'axios.js'

const ProductList = [
    {id:1,id_category:1,name:"Мини ХОТ",price:"350",active:true,art:"1234",units:"шт.",discount:true,color:"#b4deff",description:"Ролл Лосось Спайси, Ролл Окунь Спаси, Ролл Курица Шеф, 18шт., 400гр.",edit:true},
    {id:2,id_category:1,name:"Вкус Любви",price:"690",active:true,art:1234,units:"шт.",discount:false,color:"#a0c3ff",description:"Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",edit:true},
    {id:3,id_category:1,name:"Жара",price:"699",active:true,art:1234,units:"шт.",discount:true,color:"#9fffe2",description:"Волк, Феникс, Фудзияма, 24шт., 1кг.",edit:true},
    {id:4,id_category:1,name:"Филадельфия Микс",price:"699",active:true,art:1234,units:"шт.",discount:false,color:"#52ff77",description:"филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",edit:true},
    {id:5,id_category:1,name:"Сет Хот",price:"790",active:true,art:1234,units:"шт.",discount:false,color:"#ffabf2",description:"волк, восстание, хоккайдо, 24 шт., 1000 гр.",edit:true},
    {id:6,id_category:1,name:"Каникулы",price:"925",active:true,art:1234,units:"шт.",discount:false,color:"#ff588d",description:"Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",edit:true},
    {id:7,id_category:1,name:"Наслаждение",price:"999",active:true,art:1234,units:"шт.",discount:false,color:"#ffb43b",description:"Люкс, Нежность, Филадельфия под угрем, 24шт., 850гр.",edit:true},
    {id:8,id_category:1,name:"Хайп",price:"1800",active:true,art:1234,units:"шт.",discount:true,color:"#f2ff48",description:"Филадельфия (2шт), Филадельфия max, Летний, Лосось, суши лосось, Волк, Феникс, Фудзияма, Хот Лосось, 71шт., 2175гр.",edit:true},
    {id:9,id_category:1,name:"Ред Фиш",price:"1499",active:true,art:1234,units:"шт.",discount:false,color:"#ff5382",description:"Филадельфия МАХ, Волк, ролл Лосось, Мажор, Грейт Ролл, Сяке темпура, Немо, 54шт., 2кг.",edit:true},
    {id:10,id_category:2,name:"Немо",price:"245",active:true,art:1234,units:"шт.",discount:false,color:"#78ffd1",description:"Рис, нори, сливочный сыр, огурец, тамаго, окунь, лосось, 280 гр.",edit:true},
    {id:11,id_category:2,name:"Пандора",price:"400",active:true,art:1234,units:"шт.",discount:false,color:"#76bcff",description:"Рис, нори, японский майонез, огурец, тамаго, зеленый лук, тигровая креветка, масаго, лосось, 330гр.",edit:true},
    {id:12,id_category:2,name:"Дуэт",price:"250",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Рис, нори, сливочный сыр, огурец, тамаго, окунь, огурец - лосось, 310гр.",edit:true},
    {id:13,id_category:2,name:"Сегун",price:"290",active:true,art:1234,units:"шт.",discount:true,color:"#ffeedd",description:"Рис, нори, сливочный сыр, тамаго, зеленый лук, мидии, тигровая креветка, стружка тунца, 270гр.",edit:true},
    {id:14,id_category:3,name:"Суши Икура",price:"120",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"42гр.",edit:true},
    {id:15,id_category:3,name:"Суши Тигровая Креветка",price:"75",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"42гр.",edit:true},
    {id:16,id_category:3,name:"Суши Лосось",price:"60",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"42гр.",edit:true},
    {id:17,id_category:3,name:"Суши Угорь",price:"90",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"42гр.",edit:true},
    {id:18,id_category:4,name:"Маргарита (Томатная основа)",price:"340",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Описание товара",edit:true},
    {id:19,id_category:4,name:"Пикантная (Кайенская основа)",price:"370",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Описание товара",edit:true},
    {id:20,id_category:4,name:"Морская Премиум (Сливочная основа)",price:"499",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Описание товара",edit:true},
    {id:21,id_category:4,name:"Деревенская (сливочно-горчичная основа)",price:"370",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Описание товара",edit:true},
    {id:22,id_category:5,name:"Паста Карбонара",price:"270",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Лапша Рамен, Сливки, Бекон, Вино, Лук зеленый, Приправа Оригано, Шампиньоны, Яйцо, Сыр.",edit:true},
    {id:23,id_category:5,name:"Удон с курицей и беконом",price:"260",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Пшеничная лапша обжаренная с курицей, бекон, фасоль, лук, морковь, кабачок, брокколи, грибы шампиньоны, соус карри, кокосовое молоко, кунжут (400гр).",edit:true},
    {id:24,id_category:5,name:"Рамен сливочный с курицей",price:"235",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Яичная лапша, Курица, Лук репчатый, фасоль стручковая, Кабачок, Брокколи, грибы Шампиньоны, Сливки, Соевый соус, Зеленый лук, Кунжут 390 гр.",edit:true},
    {id:25,id_category:5,name:"Удон сливочный с креветкой и лососем",price:"320",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Пшеничная лапша, Тигровая креветка, Лосось, Овощная смесь (Лук репчатый, Кабачок, Брокколи, грибы Шампиньоны), Соевый соус, Сливочный соус, Кунжут, Зеленый лук, 370 гр.",edit:true},
    {id:26,id_category:6,name:"Мисо суп с окунем и кальмаром",price:"200",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Бульон Мисо, Кальмар командорский, Окунь, Вакаме, Сыр Тофу, Кунжут, Лук зеленый, 380 гр.",edit:true},
    {id:27,id_category:6,name:"Сливочный суп с лососем",price:"300",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Бульон мисо, Лосось, Брокколи, Кабачок, Сливки, Кунжут, Зеленый лук, 350 гр.",edit:true},
    {id:28,id_category:7,name:"Салат копченый с Лососем",price:"260",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Салат листовой, лосось копченый, огурец, помидор, перец, соус чесночный, кунжут, 230гр.",edit:true},
    {id:29,id_category:7,name:"Салат с Тигровой Креветкой",price:"230",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Салат листовой, креветка тигровая обжаренная, огурец, помидор, перец, соус горчичный, кунжут, 240гр.",edit:true},
    {id:30,id_category:8,name:"Мидии под сырным соусом (Бусидо)",price:"350",active:true,art:1234,units:"шт.",discount:false,color:"#ffeedd",description:"Мидии Киви, Сырный соус (Майонез, Чеснок, Сыр, Масаго), 240 гр.",edit:true},
];

export default ProductList;


const getAllProductListUser = async ()=>{
    const response = await axios.get(buildApiUrl('catalog/getAllProductList/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllProductListUser = data;

    if (error || result === 'error') {
        return {
            __error: true,
            error: error || 'Error Billing Feature',
            errorInfo: errorInfo || message || 'Ошибка загрузки товаров',
            result: result || 'error',
        };
    }

    return AllProductListUser;
};

const getCatalogByPointUser = async (pointId, includeDisabled = 0, brandId = 0)=>{
    const response = await axios.post(buildApiUrl('catalog/getCatalogByPoint/'),{
        point_id: pointId,
        brand_id: brandId,
        include_disabled: includeDisabled ? 1 : 0
    });
    const data = response && response.data ? response.data : {};
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.data)) return data.data;
    return [];
};

const revalidateCartByPointUser = async (pointId, lines = [], brandId = 0)=>{
    const response = await axios.post(buildApiUrl('catalog/revalidateCartByPoint/'),{
        point_id: pointId,
        brand_id: brandId,
        lines: Array.isArray(lines) ? lines : []
    });
    return response && response.data ? response.data : {};
};

const getProductOverridesUser = async (productId)=>{
    try {
        const response = await axios.post(buildApiUrl('catalog/getProductOverrides/'),{
            product_id: productId
        });
        return response && response.data ? response.data : {};
    } catch (e) {
        const serverData = e?.response?.data || {};
        const errorInfo = String(serverData?.errorInfo || '');
        if (errorInfo.includes('несуществующему методу') || errorInfo.includes('Method not found')) {
            return {
                result: 'success',
                message: 'Fallback: getProductOverrides недоступен на сервере',
                data: {
                    branch_overrides: [],
                    point_overrides: []
                },
                meta: {
                    fallback: true
                }
            };
        }
        throw e;
    }
};

const upsertProductBranchOverrideUser = async (payload = {})=>{
    const response = await axios.post(buildApiUrl('catalog/upsertProductBranchOverride/'), payload);
    return response && response.data ? response.data : {};
};

const upsertProductPointOverrideUser = async (payload = {})=>{
    const response = await axios.post(buildApiUrl('catalog/upsertProductPointOverride/'), payload);
    return response && response.data ? response.data : {};
};

const deleteProductBranchOverrideUser = async (payload = {})=>{
    const response = await axios.post(buildApiUrl('catalog/deleteProductBranchOverride/'), payload);
    return response && response.data ? response.data : {};
};

const deleteProductPointOverrideUser = async (payload = {})=>{
    const response = await axios.post(buildApiUrl('catalog/deleteProductPointOverride/'), payload);
    return response && response.data ? response.data : {};
};


const setActiveProductList = async (id,val)=>{
    const response = await axios.post(buildApiUrl('catalog/setProductListActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllProductListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ProductList  - ',response);


    return AllProductListUser;
};



const setDeletedProductList = async (id,val)=>{
    const response = await axios.post(buildApiUrl('catalog/setProductListDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    if (error || result === 'error') {
        return {
            __error: true,
            error: error || 'Error Product Deleted',
            errorInfo: errorInfo || message || 'Ошибка изменения удаления товара',
            result: result || 'error',
        };
    }
    const AllProductListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ProductList  - ',response);


    return AllProductListUser;
};




const setUpdateProductList = async (dataProductListUpdate)=>{
    const response = await axios.post(buildApiUrl('catalog/setProductListUpdate/'),{
        dataProductListUpdate
    }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllProductListUser = data;

    return AllProductListUser;
};

const setBulkPatchProductList = async (payload = {})=>{
    const safePayload = {
        ids: Array.isArray(payload?.ids) ? payload.ids : [],
        patch: payload?.patch && typeof payload.patch === 'object' ? payload.patch : {},
        scope: payload?.scope || 'all',
        scope_field: payload?.scope_field || 'units',
    };
    const response = await axios.post(
        buildApiUrl('catalog/setProductListBulkPatch/'),
        { payload: safePayload },
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    const {error, errorInfo, result, message, data } = response.data || {};
    if (error || result === 'error') {
        return {
            __error: true,
            error: error || 'Error Product Bulk Patch',
            errorInfo: errorInfo || message || 'Ошибка массового обновления товаров',
            result: result || 'error',
        };
    }
    return data;
};

const setUpdateProductListImg = async (imgFile)=>{
    const response = await axios.post(buildApiUrl('catalog/setProductListUpdateImg/'),
        imgFile
        , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

    const {error, errorInfo, result, message, data } = response.data;
    const AllImgLoading = data;

    return AllImgLoading[0];
};


const setSaveNewProductList = async (dataProductListUpdate)=>{
    const response = await axios.post(buildApiUrl('catalog/setSaveNewProductList/'),{
        dataProductListUpdate
    },{
        headers: {'Content-Type': 'multipart/form-data' }
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllProductListUser = data;

    return AllProductListUser;
};

Mock.onGet('/api/catalog/getAllProductList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllProductListUser = await getAllProductListUser();
    // console.log('С сервера пришло - ', AllProductListUser);

    // if (!AllProductListUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (AllProductListUser && AllProductListUser.__error) {
        return [400, AllProductListUser]
    }

    if (!AllProductListUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllProductListUser,
    ]


})


Mock.onPost('/api/catalog/setActiveProductList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllProductListUser = await setActiveProductList(id,val);

    // if (!AllProductListUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllProductListUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllProductListUser,
    ]


})

Mock.onPost('/api/catalog/setDeletedProductList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllProductListUser = await setDeletedProductList(id,val);

    // if (!AllProductListUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllProductListUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllProductListUser,
    ]


})


Mock.onPost('/api/catalog/setUpdateProductListImg').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    // let { data } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const imgSRC = await setUpdateProductListImg(config.data);

    // if (!ProductList) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!imgSRC) {
        return [400, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        imgSRC,
    ]


})

Mock.onPost('/api/catalog/setUpdateProductList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataProductListUpdate } = JSON.parse(config.data);
    const ProductList = await setUpdateProductList(dataProductListUpdate);

    // console.log('Серовер вернул данные ',AllProductListUser);

    // if (!ProductList) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!ProductList) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        ProductList,
    ]


})


Mock.onPost('/api/catalog/setSaveNewProductList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataProductListUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const ProductList = await setSaveNewProductList(dataProductListUpdate);

    // if (!ProductList) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!ProductList) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        ProductList,
    ]
})

Mock.onPost('/api/catalog/setBulkPatchProductList').reply(async (config) => {
    let payload = {};
    if (config && typeof config.data === 'string') {
        try {
            payload = JSON.parse(config.data || '{}');
        } catch (e) {
            payload = {};
        }
    } else if (config && config.data && typeof config.data === 'object') {
        payload = config.data;
    }

    const ProductList = await setBulkPatchProductList(payload);
    if (!ProductList) {
        return [200, []];
    }
    return [200, ProductList];
})

Mock.onPost('/api/catalog/getCatalogByPoint').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const pointId = payload && payload.point_id ? payload.point_id : 0;
    const includeDisabled = payload && payload.include_disabled ? 1 : 0;
    const list = await getCatalogByPointUser(pointId, includeDisabled, Number(payload.brand_id || 0));
    return [200, list || []];
})

Mock.onPost('/api/catalog/revalidateCartByPoint').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const pointId = payload && payload.point_id ? payload.point_id : 0;
    const lines = payload && Array.isArray(payload.lines) ? payload.lines : [];
    const result = await revalidateCartByPointUser(pointId, lines, Number(payload.brand_id || 0));
    return [200, result];
})

Mock.onPost('/api/catalog/getProductOverrides').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const productId = payload && payload.product_id ? payload.product_id : 0;
    const result = await getProductOverridesUser(productId);
    return [200, result];
})

Mock.onPost('/api/catalog/upsertProductBranchOverride').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const result = await upsertProductBranchOverrideUser(payload || {});
    return [200, result];
})

Mock.onPost('/api/catalog/upsertProductPointOverride').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const result = await upsertProductPointOverrideUser(payload || {});
    return [200, result];
})

Mock.onPost('/api/catalog/deleteProductBranchOverride').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const result = await deleteProductBranchOverrideUser(payload || {});
    return [200, result];
})

Mock.onPost('/api/catalog/deleteProductPointOverride').reply(async (config) => {
    let payload = {};
    try {
        payload = JSON.parse(config.data || '{}');
    } catch (e) {
        payload = {};
    }
    const result = await deleteProductPointOverrideUser(payload || {});
    return [200, result];
})
